import React, {FC} from 'react'
import * as Yup from 'yup'
import {Formik, Field, Form} from 'formik'
import {InputText, FormActions, handleErrors, Checkbox } from '@/components/form'
import {PurchaseRestrictions} from '../core/_models'
import {setSettings} from '../core/_requests'

const schema = Yup.object({
  limits: Yup.object().shape({
    daily: Yup.number().integer().typeError('limit must be a number').positive().required('Limit is required'),
    monthly: Yup.number().integer().typeError('limit must be a number').positive().required('Limit is required')
  }),
  block: Yup.object().shape({
    riskScore: Yup.number().integer().typeError('limit must be a number').positive().required('Limit is required'),
    trxFailed: Yup.number().integer().typeError('limit must be a number').positive().required('Limit is required'),
    trxPending: Yup.number().integer().typeError('limit must be a number').positive().required('Limit is required')
  }),
  maxMsisdn: Yup.number().integer().typeError('limit must be a number').positive().required('Limit is required')
})

type Props = {
  restrictions: PurchaseRestrictions
}

const PurchaseRestrictionForm: FC<Props> = ({restrictions}) => {
  return (
    <Formik
      initialValues={restrictions}
      validationSchema={schema}
      onSubmit={async (values, {setErrors}) => {
        try {
          await setSettings('purchaseRestrictions', values)
        } catch (e: unknown) {
          handleErrors(e, setErrors)
        }
      }}
    >
      {({values, resetForm }) => (
        <Form id="brand" className='form'>
          <div className="row">
            <div className="col-6">
              <Field
                name="limits.daily"
                type="number"
                component={InputText}
                label="Daily"
                description="Override daily purchase limit in credits"
                required={true}
                min={0}
              />
            </div>

            <div className="col-6">
              <Field
                name="limits.monthly"
                type="number"
                component={InputText}
                label="Monthly"
                description="Override monthly purchase limit in credits"
                required={true}
              />
            </div>
          </div>

          <div className="separator separator-dashed my-5"></div>

          <div className="row">
            <div className="col-6">
              <Field
                name="block.vpn"
                component={Checkbox}
                label="Block VPN"
                defaultChecked={values.block.vpn}
              />
            </div>

            <div className="col-6">
              <Field
                name="block.server"
                component={Checkbox}
                label="Block Server"
                defaultChecked={values.block.server === true}
              />
            </div>

            <div className="col-6">
              <Field
                name="block.proxy"
                component={Checkbox}
                label="Block Proxy"
                defaultChecked={values.block.proxy === true}
              />
            </div>

            <div className="col-6">
              <Field
                name="block.robot"
                component={Checkbox}
                label="Block Robot"
                defaultChecked={values.block.proxy === true}
              />
            </div>
          </div>

          <div className="separator separator-dashed my-5"></div>

          <div className="row">
            <div className="col-6">
              <Field
                name="block.riskScore"
                type="number"
                component={InputText}
                label="Ip risk score"
                min={0}
                max={100}
                description="Ip risk score 0 to 100"
                required={true}
              />
            </div>

            <div className="col-6">
              <Field
                name="maxMsisdn"
                type="number"
                component={InputText}
                label="Max msisdn"
                min={0}
                description="Max msisdn used"
                required={true}
              />
            </div>
          </div>

          <div className="row">
            <div className="col-6">
              <Field
                name="maxDevices"
                type="number"
                component={InputText}
                label="Max devices"
                min={0}
                description="Max devices used (user agent)"
                required={true}
              />
            </div>

            <div className="col-6">
              <Field
                name="maxIsp"
                type="number"
                component={InputText}
                label="Max Isp"
                min={0}
                description="Max isp (ip detection)"
                required={true}
              />
            </div>
          </div>

          <div className="separator separator-dashed my-5"></div>

          <div className="row">
            <div className="col-6">
              <Field
                name="block.trxPending"
                type="number"
                component={InputText}
                label="Trx pending rate"
                min={0}
                max={100}
                description="Block purchases having trx pending rate greater than"
                required={true}
              />
            </div>

            <div className="col-6">
              <Field
                name="block.trxFailed"
                type="number"
                component={InputText}
                label="TRX failed rate"
                min={0}
                max={100}
                description="Block purchases having trx failed rate greater than"
                required={true}
              />
            </div>
          </div>


          <Field
            padding="pt-0"
            component={FormActions}
            position="end"
            close={resetForm}
          />
        </Form>
      )}

    </Formik>
  )
}

export default PurchaseRestrictionForm
